import React, {useState} from 'react';
import reactDom from 'react-dom';
import EventView from "../EventView/EventView"
import './styles/sidepanel.css';


function App() {
  //githubtest 20211119

    const [isSidepanel, toogleSidepanel] = useState((window.innerWidth>1500)?true:false);

    return (
        <div className="menu-content">
        <div class="open-btn" onClick={()=>{  
          toogleSidepanel(!isSidepanel);          
        }}>☰</div>
        <div class="sidepanel" style={isSidepanel?{width :300,  height:500, opacity:1}:{width :0, height:0, opacity:0}}>
            <div class="closebtn" onClick={()=>{
            toogleSidepanel(!isSidepanel)  ;
          }}>×</div>

         <a href="#title" className="menu-item" onClick={()=>{
            
            toogleSidepanel(!isSidepanel)  ;
          }}>Start</a> 


<a href="#wellcome" className="menu-item" onClick={()=>{            
            toogleSidepanel(!isSidepanel)  ;
          }}>Willkommen</a>
            
             {/* <a href="#news" className="menu-item" onClick={()=>{
            
            toogleSidepanel(!isSidepanel)  ;
          }}>Aktuelles</a>  */}

<a href="#events" className="menu-item" onClick={()=>{
            
            toogleSidepanel(!isSidepanel)  ;
          }}>Termine</a> 

<a href="#team" className="menu-item" onClick={()=>{
            
            toogleSidepanel(!isSidepanel)  ;
          }}> Unser Vorstand</a>

        <a href="#occupation" className="menu-item" onClick={()=>{            
            toogleSidepanel(!isSidepanel);
          }}>Unsere Besetzung
        </a>
          
            

           

       <a href="#about" className="menu-item" onClick={()=>{            
            toogleSidepanel(!isSidepanel);
          }}>Über Uns
        </a>

       

        <a href="#history" className="menu-item" onClick={()=>{            
            toogleSidepanel(!isSidepanel);
          }}>Unsere Geschichte
        </a>

        <a href="#chronic" className="menu-item" onClick={()=>{            
            toogleSidepanel(!isSidepanel);
          }}>Unsere Chronik
        </a>

        
{/* 
           <div  className="menu-item" onClick={()=>{
            
            toogleSidepanel(!isSidepanel)  ;

            reactDom.render(<EventView/>, document.getElementById("mainView"))
          }}>Unsere Veranstalltungen</div>   */}        
          </div>
      </div>
        );
}

export default App;